var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "dialog-base",
        {
          attrs: {
            visible: _vm.visible,
            title: _vm.isEditMode
              ? "Cập nhật khoản thu chính"
              : "Thêm mới khoản thu chính",
            size: "lg",
            "cancel-text": "Hủy",
            "confirm-text": "Lưu lại",
            "confirm-loading": _vm.loading,
            "use-panel": false,
            top: "4vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            confirm: _vm.handleSubmit,
            cancel: _vm.handleClose,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "dataForm",
              staticClass: "sk-dialog-content",
              attrs: {
                model: _vm.dataForm,
                rules: _vm.formRules,
                "label-width": "210px",
                "label-position": "left",
              },
            },
            [
              _c(
                "div",
                { staticClass: "trf-help-entry" },
                [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content: "Xem toàn bộ hướng dẫn thao tác",
                        placement: "top",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            icon: "el-icon-question",
                            plain: "",
                            size: "small",
                          },
                          on: { click: _vm.openGuideDialog },
                        },
                        [
                          _vm._v(
                            "\n              Hướng dẫn thao tác\n            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "sk-panel mb-4" },
                [
                  _c("div", { staticClass: "sk-panel-head" }, [
                    _c("div", { staticClass: "sk-panel-icon" }, [
                      _c("i", { staticClass: "el-icon-document" }),
                    ]),
                    _c("div", [
                      _c("p", { staticClass: "sk-panel-title" }, [
                        _vm._v("Thông tin chung"),
                      ]),
                      _c("p", { staticClass: "sk-panel-subtitle" }, [
                        _vm._v("Tên, loại và mô tả khoản thu chính"),
                      ]),
                    ]),
                  ]),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { prop: "name" },
                              scopedSlots: _vm._u([
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _vm._v(
                                        "\n                Tên khoản thu\n                "
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content:
                                              "Tên hiển thị của khoản thu chính (ví dụ: Học phí tổng hợp)",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-question trf-help-icon ml-2",
                                          }),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "Nhập tên khoản thu...",
                                  maxlength: "255",
                                  "show-word-limit": "",
                                },
                                model: {
                                  value: _vm.dataForm.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dataForm, "name", $$v)
                                  },
                                  expression: "dataForm.name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { prop: "category" },
                              scopedSlots: _vm._u([
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _vm._v(
                                        "\n                Loại khoản\n                "
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content:
                                              "Chọn khoản thu hoặc khoản hoàn trả",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-question trf-help-icon ml-2",
                                          }),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "sk-u-w-full",
                                  attrs: { placeholder: "Chọn loại" },
                                  on: { change: _vm.onCategoryChange },
                                  model: {
                                    value: _vm.dataForm.category,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.dataForm, "category", $$v)
                                    },
                                    expression: "dataForm.category",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "Khoản thu", value: "IN" },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: "Khoản hoàn trả",
                                      value: "OUT",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { prop: "unit" },
                              scopedSlots: _vm._u([
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _vm._v(
                                        "\n                Đơn vị tính\n                "
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content:
                                              "Chọn đơn vị hoặc nhập mới",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-question trf-help-icon ml-2",
                                          }),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "sk-u-w-full",
                                  attrs: {
                                    filterable: "",
                                    "allow-create": "",
                                    "default-first-option": "",
                                    placeholder: "Chọn hoặc nhập đơn vị",
                                  },
                                  model: {
                                    value: _vm.dataForm.unit,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.dataForm, "unit", $$v)
                                    },
                                    expression: "dataForm.unit",
                                  },
                                },
                                _vm._l(_vm.unitsList, function (u) {
                                  return _c("el-option", {
                                    key: u,
                                    attrs: { label: u, value: u },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              scopedSlots: _vm._u([
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _vm._v(
                                        "\n                Mô tả\n                "
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content:
                                              "Mô tả ngắn về khoản thu, tối đa 255 ký tự",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-question trf-help-icon ml-2",
                                          }),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  rows: 2,
                                  autosize: "",
                                  placeholder: "Nhập mô tả...",
                                  maxlength: "255",
                                  "show-word-limit": "",
                                },
                                model: {
                                  value: _vm.dataForm.description,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dataForm, "description", $$v)
                                  },
                                  expression: "dataForm.description",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "sk-panel mb-4" },
                [
                  _c("div", { staticClass: "sk-panel-head" }, [
                    _c(
                      "div",
                      { staticClass: "sk-panel-icon sk-panel-icon--success" },
                      [_c("i", { staticClass: "el-icon-money" })]
                    ),
                    _c("div", [
                      _c("p", { staticClass: "sk-panel-title" }, [
                        _vm._v("Tài chính & Công thức"),
                      ]),
                    ]),
                  ]),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              scopedSlots: _vm._u([
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _vm._v(
                                        "\n                Áp dụng công thức\n                "
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content:
                                              "Bặt nếu muốn tính giá từ công thức tham chiếu các khoản thu gốc",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-question trf-help-icon ml-2",
                                          }),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  on: { change: _vm.onHasFormulaChange },
                                  model: {
                                    value: _vm.dataForm.hasFormula,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.dataForm, "hasFormula", $$v)
                                    },
                                    expression: "dataForm.hasFormula",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: true } }, [
                                    _vm._v("Có"),
                                  ]),
                                  _c("el-radio", { attrs: { label: false } }, [
                                    _vm._v("Không"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      [
                        !_vm.dataForm.hasFormula
                          ? _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: { prop: "price" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "label",
                                          fn: function () {
                                            return [
                                              _vm._v(
                                                "\n                  Đơn giá (VNĐ)\n                  "
                                              ),
                                              _c(
                                                "el-tooltip",
                                                {
                                                  attrs: {
                                                    content:
                                                      "Đơn giá cho 1 đơn vị tính (VNĐ)",
                                                    placement: "top",
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-question trf-help-icon ml-2",
                                                  }),
                                                ]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      4021855187
                                    ),
                                  },
                                  [
                                    _c("ElCurrencyInput", {
                                      staticClass: "sk-u-w-full",
                                      attrs: {
                                        options: {
                                          locale: "vi-VN",
                                          precision: 0,
                                          autoDecimalMode: false,
                                          distractionFree: false,
                                        },
                                      },
                                      on: { input: _vm.calculatePreview },
                                      model: {
                                        value: _vm.dataForm.price,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.dataForm, "price", $$v)
                                        },
                                        expression: "dataForm.price",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: { prop: "quantity" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "label",
                                    fn: function () {
                                      return [
                                        _vm._v(
                                          "\n                  Số lượng\n                  "
                                        ),
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              content:
                                                "Số lượng đơn vị (ví dụ: 1)",
                                              placement: "top",
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-question trf-help-icon ml-2",
                                            }),
                                          ]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                              },
                              [
                                _c("el-input", {
                                  staticClass: "sk-u-w-full",
                                  attrs: {
                                    type: "number",
                                    step: _vm.allowDecimal ? 0.01 : 1,
                                  },
                                  on: { input: _vm.calculatePreview },
                                  model: {
                                    value: _vm.dataForm.quantity,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.dataForm,
                                        "quantity",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression: "dataForm.quantity",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "Cho phép số thập phân" } },
                              [
                                _c("el-switch", {
                                  attrs: {
                                    value: _vm.allowDecimal,
                                    "active-text": "Có",
                                    "inactive-text": "Không",
                                  },
                                  on: { change: _vm.handleAllowDecimalChange },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: { prop: "discount" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "label",
                                    fn: function () {
                                      return [
                                        _vm._v(
                                          "\n                  Giảm giá\n                  "
                                        ),
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              content:
                                                "Bật nếu muốn áp dụng chính sách giảm giá",
                                              placement: "top",
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-question trf-help-icon ml-2",
                                            }),
                                          ]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                              },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    on: { change: _vm.onDiscountChange },
                                    model: {
                                      value: _vm.dataForm.discount,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.dataForm, "discount", $$v)
                                      },
                                      expression: "dataForm.discount",
                                    },
                                  },
                                  [
                                    _c("el-radio", { attrs: { label: true } }, [
                                      _vm._v("Có"),
                                    ]),
                                    _c(
                                      "el-radio",
                                      { attrs: { label: false } },
                                      [_vm._v("Không")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.dataForm.discount
                          ? _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: { prop: "discountType" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "label",
                                          fn: function () {
                                            return [
                                              _vm._v(
                                                "\n                  Loại giảm giá\n                  "
                                              ),
                                              _c(
                                                "el-tooltip",
                                                {
                                                  attrs: {
                                                    content:
                                                      "Phần trăm (%) hoặc số tiền (VNĐ)",
                                                    placement: "top",
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-question trf-help-icon ml-2",
                                                  }),
                                                ]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      3767970409
                                    ),
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "sk-u-w-full",
                                        attrs: { placeholder: "Chọn loại" },
                                        on: { change: _vm.calculatePreview },
                                        model: {
                                          value: _vm.dataForm.discountType,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.dataForm,
                                              "discountType",
                                              $$v
                                            )
                                          },
                                          expression: "dataForm.discountType",
                                        },
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: {
                                            label: "Phần trăm (%)",
                                            value: "PERCENT",
                                          },
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "Số tiền (VNĐ)",
                                            value: "MONEY",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.dataForm.discount
                          ? _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: { prop: "discountNumber" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "label",
                                          fn: function () {
                                            return [
                                              _vm.dataForm.discountType ===
                                              "PERCENT"
                                                ? _c("span", [
                                                    _vm._v(
                                                      "Phần trăm giảm (%)"
                                                    ),
                                                  ])
                                                : _c("span", [
                                                    _vm._v(
                                                      "Số tiền giảm (VNĐ)"
                                                    ),
                                                  ]),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      568855960
                                    ),
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "flex items-center" },
                                      [
                                        _vm.dataForm.discountType === "MONEY"
                                          ? [
                                              _c("ElCurrencyInput", {
                                                staticClass: "sk-u-w-full",
                                                attrs: {
                                                  options: {
                                                    locale: "vi-VN",
                                                    precision: 0,
                                                    autoDecimalMode: false,
                                                    distractionFree: false,
                                                  },
                                                },
                                                on: {
                                                  input: _vm.calculatePreview,
                                                },
                                                model: {
                                                  value:
                                                    _vm.dataForm.discountNumber,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.dataForm,
                                                      "discountNumber",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dataForm.discountNumber",
                                                },
                                              }),
                                            ]
                                          : [
                                              _c("el-input-number", {
                                                directives: [
                                                  {
                                                    name: "discount-percent",
                                                    rawName:
                                                      "v-discount-percent",
                                                  },
                                                ],
                                                staticClass: "sk-u-w-full",
                                                attrs: {
                                                  min: 0,
                                                  max: 100,
                                                  precision: 0,
                                                  "controls-position": "right",
                                                },
                                                on: {
                                                  change: _vm.calculatePreview,
                                                },
                                                model: {
                                                  value:
                                                    _vm.dataForm.discountNumber,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.dataForm,
                                                      "discountNumber",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dataForm.discountNumber",
                                                },
                                              }),
                                            ],
                                        _vm.discountAmount > 0
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "trf-discount-amount ml-3",
                                              },
                                              [
                                                _vm._v(
                                                  "-" +
                                                    _vm._s(
                                                      _vm.formatMoney(
                                                        _vm.discountAmount
                                                      )
                                                    )
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        !_vm.dataForm.hasFormula
                          ? _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "label",
                                          fn: function () {
                                            return [_vm._v("Thành tiền")]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      2661737267
                                    ),
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "trf-preview-money" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatMoney(_vm.previewSumMoney)
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: { prop: "discount" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "label",
                                    fn: function () {
                                      return [
                                        _vm._v(
                                          "\n                  Áp dụng thay đổi\n                  "
                                        ),
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              content:
                                                "Áp dụng thay đổi về số lượng, đơn giá, giảm giá, đơn vị tính và loại giảm cho những khoản học sinh đã đăng ký",
                                              placement: "top",
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-question trf-help-icon ml-2",
                                            }),
                                          ]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                              },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    model: {
                                      value:
                                        _vm.dataForm.updateRegisteredRevenue,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.dataForm,
                                          "updateRegisteredRevenue",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "dataForm.updateRegisteredRevenue",
                                    },
                                  },
                                  [
                                    _c("el-radio", { attrs: { label: true } }, [
                                      _vm._v("Có"),
                                    ]),
                                    _c(
                                      "el-radio",
                                      { attrs: { label: false } },
                                      [_vm._v("Không")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "trf-update-note",
                                class: _vm.dataForm.updateRegisteredRevenue
                                  ? "trf-update-note--apply"
                                  : "trf-update-note--skip",
                              },
                              [
                                _c("i", {
                                  class: _vm.dataForm.updateRegisteredRevenue
                                    ? "el-icon-success"
                                    : "el-icon-warning-outline",
                                }),
                                _vm.dataForm.updateRegisteredRevenue === true
                                  ? _c("span", [
                                      _vm._v(
                                        "Thay đổi sẽ được áp dụng với những khoản học sinh đã đăng ký đã khởi tạo."
                                      ),
                                    ])
                                  : _c("span", [
                                      _vm._v(
                                        "Thay đổi sẽ không được áp dụng với những khoản học sinh đã đăng ký đã khởi tạo."
                                      ),
                                    ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      _vm.dataForm.hasFormula
                        ? [
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "label",
                                          fn: function () {
                                            return [
                                              _vm._v(
                                                "\n                  Khai báo biến công thức\n                  "
                                              ),
                                              _c(
                                                "el-tooltip",
                                                {
                                                  attrs: {
                                                    content:
                                                      "Khai báo tên biến (A-Z) và ánh xạ biến sang khoản thu gốc tương ứng",
                                                    placement: "top",
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-question trf-help-icon ml-2",
                                                  }),
                                                ]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      1278108333
                                    ),
                                  },
                                  [
                                    _c(
                                      "el-row",
                                      {
                                        staticClass: "trf-mapping-header mb-1",
                                        attrs: { gutter: 10 },
                                      },
                                      [
                                        _c("el-col", { attrs: { span: 5 } }, [
                                          _c(
                                            "span",
                                            { staticClass: "trf-col-label" },
                                            [_vm._v("Biến")]
                                          ),
                                        ]),
                                        _c("el-col", { attrs: { span: 17 } }, [
                                          _c(
                                            "span",
                                            { staticClass: "trf-col-label" },
                                            [
                                              _vm._v(
                                                "Khoản thu sử dụng để tính toán"
                                              ),
                                            ]
                                          ),
                                        ]),
                                        _c("el-col", { attrs: { span: 2 } }),
                                      ],
                                      1
                                    ),
                                    _vm.dataForm.formulaMappings.length === 0
                                      ? _c(
                                          "div",
                                          { staticClass: "trf-empty-hint" },
                                          [
                                            _vm._v(
                                              '\n                  Nhấn "+ Thêm biến" để sử dụng trong biểu thức công thức.\n                '
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._l(
                                      _vm.dataForm.formulaMappings,
                                      function (mapping, idx) {
                                        return _c(
                                          "div",
                                          {
                                            key: idx,
                                            staticClass: "trf-mapping-row mb-2",
                                          },
                                          [
                                            _c(
                                              "el-row",
                                              {
                                                attrs: {
                                                  gutter: 10,
                                                  align: "middle",
                                                  type: "flex",
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 5 } },
                                                  [
                                                    _c("el-input", {
                                                      staticStyle: {
                                                        "text-transform":
                                                          "uppercase",
                                                      },
                                                      attrs: {
                                                        placeholder: "Ví dụ: A",
                                                        size: "small",
                                                        maxlength: "1",
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          return _vm.onMappingAliasInput(
                                                            mapping
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value: mapping.alias,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            mapping,
                                                            "alias",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "mapping.alias",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 17 } },
                                                  [
                                                    _c(
                                                      "el-select",
                                                      {
                                                        staticClass:
                                                          "sk-u-w-full",
                                                        attrs: {
                                                          filterable: "",
                                                          placeholder:
                                                            "Chọn khoản thu sử dụng để tính ",
                                                          size: "small",
                                                          loading:
                                                            _vm.principalRevenueLoading,
                                                        },
                                                        model: {
                                                          value:
                                                            mapping.idPrincipalRevenue,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              mapping,
                                                              "idPrincipalRevenue",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "mapping.idPrincipalRevenue",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.principalRevenueOptions,
                                                        function (pr) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: pr.id,
                                                              attrs: {
                                                                label:
                                                                  pr.name +
                                                                  " — " +
                                                                  _vm.formatMoney(
                                                                    pr.price
                                                                  ),
                                                                value: pr.id,
                                                              },
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  {
                                                    staticClass: "text-right",
                                                    attrs: { span: 2 },
                                                  },
                                                  [
                                                    _c("el-button", {
                                                      attrs: {
                                                        type: "danger",
                                                        icon: "el-icon-delete",
                                                        size: "mini",
                                                        circle: "",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.removeMapping(
                                                            idx
                                                          )
                                                        },
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "small",
                                          icon: "el-icon-plus",
                                          plain: "",
                                        },
                                        on: { click: _vm.addMapping },
                                      },
                                      [_vm._v("Thêm biến")]
                                    ),
                                  ],
                                  2
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: { prop: "formulaExpression" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "label",
                                          fn: function () {
                                            return [
                                              _vm._v(
                                                "\n                  Biểu thức công thức\n                  "
                                              ),
                                              _c(
                                                "el-tooltip",
                                                {
                                                  attrs: {
                                                    content:
                                                      "Nhập công thức bằng các biến đã khai báo ở trên. Ví dụ: (A + B) * 0.9",
                                                    placement: "top",
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-question trf-help-icon ml-2",
                                                  }),
                                                ]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      238922953
                                    ),
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        placeholder: "Ví dụ: (A + B) * 0.9",
                                        maxlength: "500",
                                        "show-word-limit": "",
                                      },
                                      on: {
                                        input: _vm.onFormulaExpressionInput,
                                      },
                                      model: {
                                        value: _vm.dataForm.formulaExpression,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.dataForm,
                                            "formulaExpression",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "dataForm.formulaExpression",
                                      },
                                    }),
                                    _vm.formulaUnknownAliases.length > 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "trf-formula-warning mt-2",
                                          },
                                          [
                                            _vm._v(
                                              "\n                  Biểu thức đang dùng biến chưa khai báo: " +
                                                _vm._s(
                                                  _vm.formulaUnknownAliases.join(
                                                    ", "
                                                  )
                                                ) +
                                                "\n                "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.formulaExpressionName
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 24 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "label",
                                              fn: function () {
                                                return [
                                                  _vm._v(
                                                    "\n                  Công thức (đã dịch)\n                  "
                                                  ),
                                                  _c(
                                                    "el-tooltip",
                                                    {
                                                      attrs: {
                                                        content:
                                                          "Công thức với tên khoản thu thay thế biến",
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-question trf-help-icon ml-2",
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          false,
                                          3094531212
                                        ),
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "trf-formula-name" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.formulaExpressionName)
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "sk-panel mb-4" },
                [
                  _c("div", { staticClass: "sk-panel-head" }, [
                    _c(
                      "div",
                      { staticClass: "sk-panel-icon sk-panel-icon--warning" },
                      [_c("i", { staticClass: "el-icon-tickets" })]
                    ),
                    _c("div", [
                      _c("p", { staticClass: "sk-panel-title" }, [
                        _vm._v("Thuế & Hóa đơn"),
                      ]),
                      _c("p", { staticClass: "sk-panel-subtitle" }, [
                        _vm._v(
                          "Khai báo thuế GTGT và phát hành hóa đơn điện tử"
                        ),
                      ]),
                    ]),
                  ]),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              scopedSlots: _vm._u([
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _vm._v(
                                        "\n                Khai báo thuế\n                "
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content:
                                              "Bật nếu khoản thu này phải khai báo thuế GTGT",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-question trf-help-icon ml-2",
                                          }),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  on: { change: _vm.onTaxDeclarationChange },
                                  model: {
                                    value: _vm.dataForm.taxDeclaration,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.dataForm,
                                        "taxDeclaration",
                                        $$v
                                      )
                                    },
                                    expression: "dataForm.taxDeclaration",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: true } }, [
                                    _vm._v("Có"),
                                  ]),
                                  _c(
                                    "el-radio",
                                    {
                                      attrs: {
                                        label: false,
                                        disabled:
                                          _vm.dataForm
                                            .issuingElectronicInvoices,
                                      },
                                    },
                                    [_vm._v("Không")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.dataForm.taxDeclaration
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { prop: "taxPercentage" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "label",
                                        fn: function () {
                                          return [
                                            _vm._v(
                                              "\n                Thuế GTGT\n                "
                                            ),
                                            _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  content:
                                                    "Chọn loại thuế GTGT áp dụng",
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-question trf-help-icon ml-2",
                                                }),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    3979162848
                                  ),
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: { placeholder: "-- Lựa chọn --" },
                                      on: { change: _vm.handleTaxChange },
                                      model: {
                                        value: _vm.dataForm.taxPercentage,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.dataForm,
                                            "taxPercentage",
                                            $$v
                                          )
                                        },
                                        expression: "dataForm.taxPercentage",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: {
                                          label: "Khác",
                                          value: "other",
                                        },
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: "Không chịu thuế",
                                          value: "-2",
                                        },
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: "Không kê khai",
                                          value: "-1",
                                        },
                                      }),
                                      _c("el-option", {
                                        attrs: { label: "0%", value: "0" },
                                      }),
                                      _c("el-option", {
                                        attrs: { label: "5%", value: "5" },
                                      }),
                                      _c("el-option", {
                                        attrs: { label: "8%", value: "8" },
                                      }),
                                      _c("el-option", {
                                        attrs: { label: "10%", value: "10" },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.dataForm.taxDeclaration &&
                      String(_vm.dataForm.taxPercentage) === "other"
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { prop: "taxPercentageInput" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "label",
                                        fn: function () {
                                          return [
                                            _vm._v(
                                              "\n                Thuế khác (%)\n                "
                                            ),
                                            _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  content:
                                                    "Nhập phần trăm thuế tùy chỉnh",
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-question trf-help-icon ml-2",
                                                }),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    330924941
                                  ),
                                },
                                [
                                  _c("el-input-number", {
                                    staticClass: "sk-u-w-full",
                                    attrs: {
                                      controls: false,
                                      min: 0,
                                      placeholder: "Nhập %",
                                    },
                                    model: {
                                      value: _vm.dataForm.taxPercentageInput,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.dataForm,
                                          "taxPercentageInput",
                                          $$v
                                        )
                                      },
                                      expression: "dataForm.taxPercentageInput",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              scopedSlots: _vm._u([
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _vm._v(
                                        "\n                Hóa đơn điện tử\n                "
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content:
                                              "Bật nếu khoản thu cần phát hành hóa đơn điện tử",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-question trf-help-icon ml-2",
                                          }),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  on: {
                                    change:
                                      _vm.onIssuingElectronicInvoicesChange,
                                  },
                                  model: {
                                    value:
                                      _vm.dataForm.issuingElectronicInvoices,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.dataForm,
                                        "issuingElectronicInvoices",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "dataForm.issuingElectronicInvoices",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: true } }, [
                                    _vm._v("Có"),
                                  ]),
                                  _c("el-radio", { attrs: { label: false } }, [
                                    _vm._v("Không"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "sk-panel mb-4" },
                [
                  _c("div", { staticClass: "sk-panel-head" }, [
                    _c(
                      "div",
                      { staticClass: "sk-panel-icon sk-panel-icon--warning" },
                      [_c("i", { staticClass: "el-icon-date" })]
                    ),
                    _c("div", [
                      _c("p", { staticClass: "sk-panel-title" }, [
                        _vm._v("Thời gian áp dụng"),
                      ]),
                      _c("p", { staticClass: "sk-panel-subtitle" }, [
                        _vm._v(
                          "Cấu hình tháng, khoảng thời gian hoặc số đơn vị áp dụng"
                        ),
                      ]),
                    ]),
                  ]),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { prop: "appliedTimeType" },
                              scopedSlots: _vm._u([
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _vm._v(
                                        "\n                Kiểu thời gian\n                "
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content:
                                              "Loại chu kỳ áp dụng cho khoản thu",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-question trf-help-icon ml-2",
                                          }),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "sk-u-w-full",
                                  attrs: { placeholder: "Chọn kiểu thời gian" },
                                  on: { change: _vm.onAppliedTimeTypeChange },
                                  model: {
                                    value: _vm.dataForm.appliedTimeType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.dataForm,
                                        "appliedTimeType",
                                        $$v
                                      )
                                    },
                                    expression: "dataForm.appliedTimeType",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: "Theo tháng",
                                      value: "MONTH",
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: "Theo khoảng ngày",
                                      value: "TIME_PERIOD",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.dataForm.appliedTimeType === "MONTH"
                        ? [
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "label",
                                          fn: function () {
                                            return [
                                              _vm._v(
                                                "\n                  Tháng áp dụng\n                  "
                                              ),
                                              _c(
                                                "el-tooltip",
                                                {
                                                  attrs: {
                                                    content:
                                                      "Chọn các tháng trong năm mà khoản thu này được áp dụng",
                                                    placement: "top",
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-question trf-help-icon ml-2",
                                                  }),
                                                ]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      3587217984
                                    ),
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "trf-month-grid" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              width: "100%",
                                              display: "flex",
                                              "justify-content": "flex-end",
                                              "margin-bottom": "6px",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-checkbox",
                                              {
                                                model: {
                                                  value: _vm.monthsAll,
                                                  callback: function ($$v) {
                                                    _vm.monthsAll = $$v
                                                  },
                                                  expression: "monthsAll",
                                                },
                                              },
                                              [_vm._v("Chọn tất cả")]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._l(_vm.monthList, function (m) {
                                          return _c("el-checkbox", {
                                            key: m.key,
                                            staticClass: "trf-month-cb",
                                            attrs: {
                                              label: m.label,
                                              border: "",
                                              size: "small",
                                            },
                                            model: {
                                              value: _vm.dataForm[m.key],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.dataForm,
                                                  m.key,
                                                  $$v
                                                )
                                              },
                                              expression: "dataForm[m.key]",
                                            },
                                          })
                                        }),
                                      ],
                                      2
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                      _vm.dataForm.appliedTimeType === "TIME_PERIOD"
                        ? [
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop: "startDate",
                                      label: "Ngày bắt đầu",
                                    },
                                  },
                                  [
                                    _c("el-date-picker", {
                                      staticClass: "sk-u-w-full",
                                      attrs: {
                                        type: "date",
                                        placeholder: "Chọn ngày bắt đầu",
                                        "value-format": "yyyy-MM-dd",
                                      },
                                      model: {
                                        value: _vm.dataForm.startDate,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.dataForm,
                                            "startDate",
                                            $$v
                                          )
                                        },
                                        expression: "dataForm.startDate",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop: "endDate",
                                      label: "Ngày kết thúc",
                                    },
                                  },
                                  [
                                    _c("el-date-picker", {
                                      staticClass: "sk-u-w-full",
                                      attrs: {
                                        type: "date",
                                        placeholder: "Chọn ngày kết thúc",
                                        "value-format": "yyyy-MM-dd",
                                      },
                                      model: {
                                        value: _vm.dataForm.endDate,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.dataForm, "endDate", $$v)
                                        },
                                        expression: "dataForm.endDate",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "sk-panel" },
                [
                  _c("div", { staticClass: "sk-panel-head" }, [
                    _c(
                      "div",
                      { staticClass: "sk-panel-icon sk-panel-icon--danger" },
                      [_c("i", { staticClass: "el-icon-user" })]
                    ),
                    _c("div", [
                      _c("p", { staticClass: "sk-panel-title" }, [
                        _vm._v("Cấu hình điểm danh"),
                      ]),
                      _c("p", { staticClass: "sk-panel-subtitle" }, [
                        _vm._v("Thiết lập tính phí theo điểm danh thực tế "),
                      ]),
                    ]),
                  ]),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { prop: "attendance" },
                              scopedSlots: _vm._u([
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _vm._v(
                                        "\n                Áp dụng điểm danh\n                "
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content:
                                              "Bật nếu khoản thu tính dựa trên điểm danh thực tế",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-question trf-help-icon ml-2",
                                          }),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  on: { change: _vm.onAttendanceChange },
                                  model: {
                                    value: _vm.dataForm.attendance,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.dataForm, "attendance", $$v)
                                    },
                                    expression: "dataForm.attendance",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: true } }, [
                                    _vm._v("Có"),
                                  ]),
                                  _c("el-radio", { attrs: { label: false } }, [
                                    _vm._v("Không"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.dataForm.attendance
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { prop: "calculationMethod" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "label",
                                        fn: function () {
                                          return [
                                            _vm._v(
                                              "\n                Phương pháp tính\n                "
                                            ),
                                            _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  content:
                                                    "Tính trước: tính theo lịch học. Tính sau: tính theo điểm danh thực tế.",
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-question trf-help-icon ml-2",
                                                }),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    944187071
                                  ),
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      attrs: {
                                        disabled:
                                          _vm.dataForm.category === "OUT",
                                      },
                                      on: { change: _vm.resetAttendanceMethod },
                                      model: {
                                        value: _vm.dataForm.calculationMethod,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.dataForm,
                                            "calculationMethod",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "dataForm.calculationMethod",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        {
                                          attrs: {
                                            label: "BEFORE",
                                            disabled:
                                              _vm.dataForm.category === "OUT",
                                          },
                                        },
                                        [_vm._v("Tính trước")]
                                      ),
                                      _c(
                                        "el-radio",
                                        { attrs: { label: "AFTER" } },
                                        [_vm._v("Tính sau")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.dataForm.attendance &&
                      _vm.attendanceTypeCurrentList.length > 0
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { prop: "attendanceType" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "label",
                                        fn: function () {
                                          return [
                                            _vm._v(
                                              "\n                Loại điểm danh\n                "
                                            ),
                                            _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  content:
                                                    "Chọn loại điểm danh tương ứng với phương pháp tính.",
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-question trf-help-icon ml-2",
                                                }),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    3459677346
                                  ),
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "sk-u-w-full",
                                      attrs: {
                                        placeholder: "Chọn loại điểm danh",
                                      },
                                      on: {
                                        change: _vm.changeAttendanceTypeMethod,
                                      },
                                      model: {
                                        value: _vm.dataForm.attendanceType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.dataForm,
                                            "attendanceType",
                                            $$v
                                          )
                                        },
                                        expression: "dataForm.attendanceType",
                                      },
                                    },
                                    _vm._l(
                                      _vm.attendanceTypeCurrentList,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item.key,
                                          attrs: {
                                            value: item.key,
                                            label: item.value,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.dataForm.attendance &&
                      _vm.configKeyCurrentList.length > 0
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { prop: "configKey" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "label",
                                        fn: function () {
                                          return [
                                            _vm._v(
                                              "\n                Chi tiết\n                "
                                            ),
                                            _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  content:
                                                    "Chọn chi tiết tương ứng với loại điểm danh.",
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-question trf-help-icon ml-2",
                                                }),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    3496153738
                                  ),
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "sk-u-w-full",
                                      attrs: { placeholder: "Chọn chi tiết" },
                                      model: {
                                        value: _vm.dataForm.configKey,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.dataForm,
                                            "configKey",
                                            $$v
                                          )
                                        },
                                        expression: "dataForm.configKey",
                                      },
                                    },
                                    _vm._l(
                                      _vm.configKeyCurrentList,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item.key,
                                          attrs: {
                                            value: item.key,
                                            label: item.value,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.dataForm.attendance &&
                      _vm.dataForm.category === "IN" &&
                      _vm.dataForm.calculationMethod === "AFTER" &&
                      _vm.dataForm.attendanceType === "LATE"
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "label",
                                        fn: function () {
                                          return [
                                            _vm._v(
                                              "\n                Giờ đón về\n                "
                                            ),
                                            _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  content:
                                                    "Thời gian đón về chuẩn (giờ:phút), dùng để xác định khung đón muộn.",
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-question trf-help-icon ml-2",
                                                }),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    2940015833
                                  ),
                                },
                                [
                                  _c("el-time-picker", {
                                    staticClass: "sk-u-w-full",
                                    attrs: {
                                      format: "HH:mm",
                                      "picker-options": { format: "HH:mm" },
                                      "value-format": "HH:mm",
                                      placeholder: "Chọn giờ đón về",
                                    },
                                    model: {
                                      value: _vm.dataForm.configTime,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.dataForm,
                                          "configTime",
                                          $$v
                                        )
                                      },
                                      expression: "dataForm.configTime",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.dataForm.attendance &&
                      _vm.dataForm.category === "IN" &&
                      _vm.dataForm.calculationMethod === "AFTER" &&
                      _vm.dataForm.attendanceType === "LATE"
                        ? _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "label",
                                        fn: function () {
                                          return [
                                            _vm._v(
                                              "\n                Cấu hình đón muộn\n                "
                                            ),
                                            _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  content:
                                                    "Mỗi block tương ứng 1 khoảng thời gian đón muộn và mức thu tiền tương ứng.",
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-question trf-help-icon ml-2",
                                                }),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    121510571
                                  ),
                                },
                                [
                                  _c(
                                    "el-row",
                                    {
                                      staticClass: "trf-config-header mb-1",
                                      attrs: { gutter: 10 },
                                    },
                                    [
                                      _c("el-col", { attrs: { span: 6 } }, [
                                        _c(
                                          "span",
                                          { staticClass: "trf-col-label" },
                                          [_vm._v("Tên block")]
                                        ),
                                      ]),
                                      _c("el-col", { attrs: { span: 6 } }, [
                                        _c(
                                          "span",
                                          { staticClass: "trf-col-label" },
                                          [_vm._v("Từ giờ")]
                                        ),
                                      ]),
                                      _c("el-col", { attrs: { span: 6 } }, [
                                        _c(
                                          "span",
                                          { staticClass: "trf-col-label" },
                                          [_vm._v("Đến giờ")]
                                        ),
                                      ]),
                                      _c("el-col", { attrs: { span: 5 } }, [
                                        _c(
                                          "span",
                                          { staticClass: "trf-col-label" },
                                          [_vm._v("Số tiền (VNĐ)")]
                                        ),
                                      ]),
                                      _c("el-col", { attrs: { span: 1 } }),
                                    ],
                                    1
                                  ),
                                  _vm.dataForm.configList.length === 0
                                    ? _c(
                                        "div",
                                        { staticClass: "trf-empty-hint" },
                                        [
                                          _vm._v(
                                            'Chưa có cấu hình. Nhấn "+ Thêm" để bắt đầu.'
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._l(
                                    _vm.dataForm.configList,
                                    function (cfg, idx) {
                                      return _c(
                                        "div",
                                        {
                                          key: idx,
                                          staticClass: "trf-config-row mb-2",
                                        },
                                        [
                                          _c(
                                            "el-row",
                                            {
                                              attrs: {
                                                gutter: 10,
                                                align: "middle",
                                                type: "flex",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-col",
                                                { attrs: { span: 6 } },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      placeholder:
                                                        "Tên (vd: Muộn 30 phút)",
                                                      size: "small",
                                                    },
                                                    model: {
                                                      value: cfg.configName,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          cfg,
                                                          "configName",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "cfg.configName",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                { attrs: { span: 6 } },
                                                [
                                                  _c("el-time-picker", {
                                                    staticClass: "sk-u-w-full",
                                                    attrs: {
                                                      format: "HH:mm",
                                                      "picker-options": {
                                                        format: "HH:mm",
                                                      },
                                                      "value-format": "HH:mm",
                                                      placeholder: "Từ giờ",
                                                      size: "small",
                                                    },
                                                    model: {
                                                      value:
                                                        cfg.configStartTime,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          cfg,
                                                          "configStartTime",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "cfg.configStartTime",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                { attrs: { span: 6 } },
                                                [
                                                  _c("el-time-picker", {
                                                    staticClass: "sk-u-w-full",
                                                    attrs: {
                                                      format: "HH:mm",
                                                      "picker-options": {
                                                        format: "HH:mm",
                                                      },
                                                      "value-format": "HH:mm",
                                                      placeholder: "Đến giờ",
                                                      size: "small",
                                                    },
                                                    model: {
                                                      value: cfg.configEndTime,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          cfg,
                                                          "configEndTime",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "cfg.configEndTime",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                { attrs: { span: 5 } },
                                                [
                                                  _c("ElCurrencyInput", {
                                                    staticClass: "sk-u-w-full",
                                                    attrs: {
                                                      options: {
                                                        locale: "vi-VN",
                                                        precision: 0,
                                                        autoDecimalMode: false,
                                                        distractionFree: false,
                                                      },
                                                      size: "small",
                                                    },
                                                    model: {
                                                      value: cfg.configValue,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          cfg,
                                                          "configValue",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "cfg.configValue",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                {
                                                  staticClass: "text-right",
                                                  attrs: { span: 1 },
                                                },
                                                [
                                                  _c("el-button", {
                                                    attrs: {
                                                      type: "danger",
                                                      icon: "el-icon-delete",
                                                      size: "mini",
                                                      circle: "",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.removeConfig(
                                                          idx
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "primary",
                                        size: "small",
                                        icon: "el-icon-plus",
                                        plain: "",
                                      },
                                      on: { click: _vm.addConfig },
                                    },
                                    [_vm._v("Thêm khoảng thời gian")]
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c("total-revenue-guide-dialog", { ref: "guideDialog" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }